import React, { useState } from "react";
import EAButton from "../../shared/Buttons/EAButton";
import { BsCalendarRange } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../../../features/ModalComponent";
import { DayPicker } from "react-day-picker";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import { format, isToday, isTomorrow } from "date-fns";
import { ExerciseInt } from "../../../models/ExerciseInt";
import { GDANSK_TICKET } from "../Steps/gdanskSaleStepsConsts";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
}

const GdanskDateInput: React.FC<IProps> = ({ form, setForm }) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const [open, setOpen] = useState(false);

  const getButtonTitle = () => {
    if (form.date) {
      if (isToday(form.date)) {
        return `${t("wybrana_data")}: ${t("dzisiaj")}`;
      } else if (isTomorrow(form.date)) {
        return `${t("wybrana_data")}: ${t("jutro")}`;
      } else {
        return `${t("wybrana_data")}: ${format(form.date, "yyyy-MM-dd")}`;
      }
    } else {
      return t("wybierz_date");
    }
  };

  return (
    <div className="gdansk-input-content">
      <h5 className="no-line-height">
        Wybierz datę, od której chcesz zacząć korzystać z{" "}
        {form.productMainType === GDANSK_TICKET ? "biletu" : "karnetu"}
      </h5>
      <EAButton
        title={getButtonTitle()}
        onClick={() => {
          setOpen(!open);
        }}
        variant="outlined"
        endIcon={<BsCalendarRange />}
      />

      {open && (
        <ModalComponent
          leftType=""
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("wybierz_date")}
          onAccept={() => {}}
        >
          <div className="flex-center-center calendar">
            <DayPicker
              mode="single"
              locale={locale}
              selected={form.date}
              fromDate={new Date()}
              onSelect={(date) => {
                setForm({ ...form, date: date ?? new Date(), exercise: {} as ExerciseInt });
                setOpen(false);
              }}
              showOutsideDays
              modifiersClassNames={{
                selected: "my-selected",
                today: "my-today",
              }}
            />
          </div>
        </ModalComponent>
      )}
    </div>
  );
};

export default GdanskDateInput;
